"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRef = void 0;
const react_1 = require("react");
const withRef = (render) => (0, react_1.forwardRef)(render);
exports.withRef = withRef;
//# sourceMappingURL=react.js.map